__webpack_require__.p = "/vision-ui-dashboard-pro-react/";